import React, { Fragment, useState, useCallback, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGetJobSeekerEventsQuery } from "../Store/api/CommonApi";

function JobSeeker() {
  const navigate = useNavigate();

  const { data, isError } = useGetJobSeekerEventsQuery();
  const contents = data?.data ? data?.data?.event_content[0]?.content : [];
  const wcu_contents = data?.data ? data?.data?.event_content[1]?.content : [];
  const videos = data?.data ? data?.data?.event_video : [];
  const photos = data?.data ? (data?.data?.event_photo).slice(0, 8) : [];
  const sooss_photos = data?.data ? (data?.data?.event_photo).slice(8, 11) : [];
  const hiring_photos = data?.data
    ? (data?.data?.event_photo).slice(11, 12)
    : [];

  const main_boxes = data?.data ? data?.data?.event_content[2]?.content : [];

  const flags = data?.data ? data?.data?.show_sections : {};

  const numberOfSections = Math.ceil(wcu_contents.length / 2);
  const MainBoxNumberOfSections = Math.ceil(main_boxes.length / 2);

  const [currentIndex, setCurrentIndex] = useState(null);

  const isOpen = currentIndex !== null;

  /* OPEN */
  const openLightbox = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  /* CLOSE */
  const closeLightbox = useCallback(() => {
    setCurrentIndex(null);
  }, []);

  /* NEXT */
  const nextImage = useCallback(() => {
    setCurrentIndex((prev) =>
      prev !== null ? (prev + 1) % photos.length : prev,
    );
  }, [photos.length]);

  /* PREV */
  const prevImage = useCallback(() => {
    setCurrentIndex((prev) =>
      prev !== null ? (prev - 1 + photos.length) % photos.length : prev,
    );
  }, [photos.length]);

  /* KEYBOARD EVENTS */
  useEffect(() => {
    if (!isOpen) return;

    const handleKey = (e) => {
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "Escape") closeLightbox();
    };

    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [isOpen, nextImage, prevImage, closeLightbox]);

  return (
    <Fragment>
      {/* HERO (CENTERED LIKE PDF) */}
      <section className="max-w-3xl mx-auto px-6 py-16 text-center">
        <h1 className="text-4xl font-bold mb-4">
          {data?.data?.main?.main_heading}
        </h1>
        <p className="text-gray-500 mb-3">
          <i>{data?.data?.main?.secondry_heading}</i>
        </p>
        <p className="text-gray-500">{data?.data?.main?.message_1}</p>
        <br />
        <p className="text-gray-500 ">{data?.data?.main?.message_2}</p>
      </section>
      {/* PROGRAMS (3 IN A ROW WITH IMAGES) */}
      <section className="max-w-6xl mx-auto px-6 ">
        <div className="grid md:grid-cols-3 gap-8">
          {Array.from({ length: MainBoxNumberOfSections }).map((_, index) => {
            const dataIndex = index * 2;
            const firstItem = main_boxes[dataIndex];
            const secondItem =
              main_boxes[dataIndex + 1] !== undefined
                ? main_boxes[dataIndex + 1]
                : "";
            return (
              <div
                key={index}
                className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition flex flex-col"
              >
                <h3 className="text-lg font-semibold mb-2">{firstItem}</h3>
                <p className="text-gray-600 mb-4">{secondItem}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* <div className="grid md:grid-cols-3 gap-8">
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition flex flex-col">
            <h3 className="text-lg font-semibold mb-2"> Jobs Portal</h3>
            <p className="text-gray-600 mb-4">
              Your 24/7 gateway to verified roles with our global hiring
              partners.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition flex flex-col">
            <h3 className="text-lg font-semibold mb-2"> RISE Job Fair</h3>
            <p className="text-gray-600 mb-4">
              Premier event where you meet &amp; get interviewed by inclusive
              organizations.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition flex flex-col">
            <h3 className="text-lg font-semibold mb-2"> Hiring Drive</h3>
            <p className="text-gray-600 mb-4">
              Focused, high-impact events where we fast-track your resume to
              organizations.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8 py-5">
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition flex flex-col">
            <h3 className="text-lg font-semibold mb-2">
              {" "}
              100 Queer Internship
            </h3>
            <p className="text-gray-600 mb-4">
              Paid internships designed for <i>LGBT+ Students</i> to build
              real-world experience.{" "}
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition flex flex-col">
            <h3 className="text-lg font-semibold mb-2"> SheRISE Internship</h3>
            <p className="text-gray-600 mb-4">
              Internship program for <i>Women Students</i> and early
              professionals.{" "}
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border hover:shadow-md transition flex flex-col">
            <h3 className="text-lg font-semibold mb-2">
              Masterclass &amp; Career Series
            </h3>
            <p className="text-gray-600 mb-4">
              Skill-building sessions for <i>LGBT+ &amp; Women</i>{" "}
              professionals.{" "}
            </p>
          </div>
        </div> 
      </section> */}
      {/* CAREER CONVERSATIONS */}
      <section className="max-w-6xl mx-auto px-6 py-12 text-center">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* IMAGE */}
          <img
            src={data?.data?.event_content[0].image}
            alt="Career Conversations"
            className="w-full h-64 object-cover rounded-xl"
          />
          {/* TEXT */}
          <div className="text-left">
            <h2 className="text-2xl font-semibold mb-3">
              {data?.data?.event_content[0].section_name}
            </h2>
            <ul className=" text-gray-600 space-y-2">
              {contents.map((point, index) => (
                <li key={index} dangerouslySetInnerHTML={{ __html: point }}>
                  {/* {point} */}
                  {/* <strong>{point.title}:</strong> {point.description} */}
                </li>
              ))}
              {/* <li>
                        <strong>Curated Opportunities:</strong> Find roles where you can
                        truly belong.
                     </li>
                     <li>
                        <strong>Hands-on Practice:</strong> Build real-world expertise and
                        learn while you earn.
                     </li>
                     <li>
                        <strong>Long-term Growth:</strong> Assist in your career
                        aspirations, not just a paycheck.
                     </li>
                     <li>
                        <strong>Expert Access:</strong> Personalized insights &amp;
                        mentorship from industry leaders.
                     </li> */}
            </ul>
            <br />
            {/* <p className="text-gray-600 ">
              <strong>Ready to take the next step?</strong> Your true self is
              your greatest professional asset. Let’s find the workplace that
              agrees.
            </p> */}
          </div>
        </div>
        <br />
        <br />
        <button
          onClick={() => navigate("/jobs")}
          className="text-sm border px-5 py-2 bg-indigo-600 text-white rounded-xl"
        >
          Browse Jobs &amp; Apply
        </button>
      </section>
      {/* RECENT EVENTS (VIDEOS) */}
      {flags?.recent_events && (<section className="max-w-6xl mx-auto px-6 py-12 border-t">
        <h2 className="text-2xl font-semibold mb-8">
          Some of Our Recent Events
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {videos.map((video, index) => (
            <a
              key={index}
              href={video.link}
              target="_blank"
              className="block group relative"
            >
              <img
                src={video.image}
                className="w-full h-52 object-cover rounded-xl"
              />

              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-white/80 rounded-full p-4 group-hover:scale-110 transition">
                  <i className="fas fa-play text-indigo-600" />
                </div>
              </div>
            </a>
          ))}

          {/*
          <a
            href="https://www.youtube.com/watch?v=VIDEO_ID_1"
            target="_blank"
            className="block group relative"
          >
            <img src={Event1} className="w-full h-52 object-cover rounded-xl" />
            
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-white/80 rounded-full p-4 group-hover:scale-110 transition">
                <i className="fas fa-play text-indigo-600" />
              </div>
            </div>
          </a> 
           
          <a
            href="https://www.youtube.com/watch?v=VIDEO_ID_2"
            target="_blank"
            className="block group relative"
          >
            <img src={Event1} className="w-full h-52 object-cover rounded-xl" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-white/80 rounded-full p-4 group-hover:scale-110 transition">
                <i className="fas fa-play text-indigo-600" />
              </div>
            </div>
          </a> 
           VIDEO 3 
           <a
            href="https://www.youtube.com/watch?v=VIDEO_ID_3"
            target="_blank"
            className="block group relative"
          >
            <img src={Event1} className="w-full h-52 object-cover rounded-xl" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-white/80 rounded-full p-4 group-hover:scale-110 transition">
                <i className="fas fa-play text-indigo-600" />
              </div>
            </div>
          </a>  */}
        </div>
      </section>)}
      {/* PAST EVENTS (IMAGE GALLERY WITH LIGHTBOX) */}
      {flags?.past_events && (<section className="max-w-6xl mx-auto px-6 py-12">
        <h2 className="text-2xl font-semibold mb-8">Some Of Our Past Events</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {photos.map((src, index) => (
            <img
              key={index}
              src={src?.image}
              onClick={() => openLightbox(index)}
              className="gallery-img w-full aspect-[4/6] object-cover rounded-xl cursor-pointer transition hover:scale-105"
              alt={`event-${index}`}
            />
          ))}
        </div>
      </section>)}

      {/* LIGHTBOX */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeLightbox();
          }}
        >
          {/* CLOSE */}
          <button
            onClick={closeLightbox}
            className="absolute top-5 right-6 text-white text-3xl z-50"
          >
            &times;
          </button>

          {/* PREV */}
          <button
            onClick={prevImage}
            className="absolute left-4 md:left-10 text-white text-3xl z-50"
          >
            &#10094;
          </button>

          {/* IMAGE */}
          <div className="flex items-center justify-center w-full h-full px-4">
            <img
              src={photos[currentIndex].image}
              className="max-h-[85vh] max-w-[90vw] object-contain rounded-xl shadow-lg"
              alt="preview"
            />
          </div>

          {/* NEXT */}
          <button
            onClick={nextImage}
            className="absolute right-4 md:right-10 text-white text-3xl z-50"
          >
            &#10095;
          </button>
        </div>
      )}

      {/* INSTAGRAM LINE */}
      {flags?.success_stories && (<section className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl font-semibold mb-8">
          Some Of Our Success Stories{" "}
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {sooss_photos.map((photo, index) => (
            <Link href={photo?.link} key={index}>
              <img
                src={photo.image}
                alt={`Success Story ${index + 1}`}
                className="w-full object-cover rounded-xl shadow-sm"
              />
            </Link>
          ))}
          {/* <a
            href="https://www.linkedin.com/feed/update/urn:li:activity:7408091486317207552/"
            target="_blank"
          >
            <img
              src={FresherP}
              alt="Success Story 1"
              className="w-full object-cover rounded-xl shadow-sm"
            />
          </a>
          <a
            href="https://www.linkedin.com/feed/update/urn:li:activity:7407728933107851265/"
            target="_blank"
          >
            <img
              src={StudentP}
              alt="Success Story 2"
              className="w-full object-cover rounded-xl shadow-sm"
            />
          </a>
          <a
            href="https://www.linkedin.com/feed/update/urn:li:activity:7408453707862040576/"
            target="_blank"
          >
            <img
              src={LateralP}
              alt="Success Story 3"
              className="w-full object-cover rounded-xl shadow-sm"
            />
          </a> */}
        </div>
        <br />
        <div className="max-w-6xl mx-auto text-center">
          <Link
            target="_blank"
            to={data?.data?.main?.linkdin_link}
            style={{ display: "inline-block" }}
          >
            <img
              src={data?.data?.main?.icons[0].replace(/^"|"$/g, "")}
              alt=""
            />
          </Link>
          <Link
            target="_blank"
            to={data?.data?.main?.insta_link}
            style={{ display: "inline-block" }}
          >
            <img
              src={data?.data?.main?.icons[1].replace(/^"|"$/g, "")}
              alt=""
            />
          </Link>
        </div>
      </section>)}
      {/* WHY CHOOSE US */}
      <section className="max-w-6xl mx-auto px-6 py-12 border-t">
        <h2 className="text-2xl font-semibold mb-10">
          {data?.data?.event_content[1]?.section_name}
        </h2>
        <div className="grid md:grid-cols-3 gap-10 text-gray-600">
          {Array.from({ length: numberOfSections }).map((_, index) => {
            const dataIndex = index * 2;
            const firstItem = wcu_contents[dataIndex];
            const secondItem =
              wcu_contents[dataIndex + 1] !== undefined
                ? wcu_contents[dataIndex + 1]
                : "";

            return (
              <div key={index}>
                <h3 className="font-semibold mb-2 text-gray-900">
                  {firstItem}
                  {/* {firstItem.title} */}
                  {/* {Number(index * index) + "_" + Number(index * index + 1)} */}
                </h3>
                {secondItem}
                {/* {wcu_contents[index * index + 1]} */}
              </div>
            );
          })}
          {/* <div>
                  <h3 className="font-semibold mb-2 text-gray-900">Career Growth</h3>
                  Discover roles aligned with your aspirations and long-term goals.
               </div>
               <div>
                  <h3 className="font-semibold mb-2 text-gray-900">
                     Inclusive Opportunities
                  </h3>
                  Work with companies championing diversity and inclusion.{" "}
               </div>
               <div>
                  <h3 className="font-semibold mb-2 text-gray-900">
                     Empowered Community
                  </h3>
                  Join a network where your identity and voice are valued.{" "}
               </div> */}
        </div>
      </section>
      {/* RESOURCES */}
      <section className="max-w-6xl mx-auto px-6 py-12 ">
        <div className="bg-white border rounded-xl py-8 overflow-hidden">
          <img
            src={data?.data?.event_content[1]?.image}
            className="mx-auto"
            alt=""
          />{" "}
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 mb-16">
        <h2 className="text-2xl font-semibold mb-8">
          Trusted by our hiring partner organization
        </h2>
        <div className="bg-white border rounded-xl py-8 overflow-hidden">
          <img src={hiring_photos[0]?.image} className="mx-auto" alt="" />{" "}
        </div>
      </section>
    </Fragment>
  );
}

export default JobSeeker;
